import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class BreadcrumbService {
    readonly Breadcrumbs = this.router.events.pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => this.CreateBreadcrumbs(this.activatedRoute.snapshot))
    );

    constructor(private router: Router, private activatedRoute: ActivatedRoute) {
    }

    CreateBreadcrumbs(route: ActivatedRouteSnapshot): MenuItem[] {
        const items: MenuItem[] = [];

        let node = route;

        while (node) {
            if (node.data && node.data.label) {
                items.push({
                    label: node.data.label,
                    routerLink: node.pathFromRoot
                        .map(v => v.url.map(segment => segment.toString()).join('/'))
                        .join('/')
                });
            }

            node = node.children[0];
        }

        return items;
    }
}
